import { ObjectMapper } from "json-object-mapper";
import { ApprovalScopeActionType } from "services/enums/approvalScopeActionType.enum";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";
import { ApprovalScopeItemActionModel } from "./approval-scope-item-action.model";

export class ApprovalScopeItemModel extends Model implements IModel<ApprovalScopeItemModel> {
  name: string = "";
  description: string = "";
  approvalScopeId: string = "";
  sequence: number = 0;
  approveHierarchyLevelIds: string[] = [];
  approveAccessProfileIds: string[] = [];
  approveEmployeeIds: string[] = [];
  actionType: string = ApprovalScopeActionType.NONE.value; // ApprovalScopeActionType
  canBeInterrupted: boolean = true;
  useHierarchy: boolean = false;
  customFieldIds: string[] = [];
  observerEmployeeIds: string[] = [];
  stepInstructions: string = "";
  approvalScopeItemActions: ApprovalScopeItemActionModel[] = []

  static create(input: any): ApprovalScopeItemModel {
    if (!input) {
      return new ApprovalScopeItemModel();
    }

    const model = ObjectMapper.deserialize<ApprovalScopeItemModel>(
      ApprovalScopeItemModel,
      input
    );

    if (input.approvalScopeItemActions && Array.isArray(input.approvalScopeItemActions)) {
      model.approvalScopeItemActions = input.approvalScopeItemActions.map((action: any) =>
        ApprovalScopeItemActionModel.create(action)
      );
    }

    return model;
  }
}

